import { render, staticRenderFns } from "./newsContent.vue?vue&type=template&id=51affd98&scoped=true"
import script from "./newsContent.vue?vue&type=script&lang=js"
export * from "./newsContent.vue?vue&type=script&lang=js"
import style0 from "./newsContent.vue?vue&type=style&index=0&id=51affd98&prod&lang=scss"
import style1 from "./newsContent.vue?vue&type=style&index=1&id=51affd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51affd98",
  null
  
)

export default component.exports